<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-card pa-0>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          ></v-text-field>     
          <!--<v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>-->
          <router-link :to="{path: formPath}">
            <v-btn color="success" fab small dark>
              <v-icon>add</v-icon>
            </v-btn>  
          </router-link>              
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0" id="branch-scroll">
          <v-data-table

            :headers="complex.headers"
            :search="search"
            :items="complex.items"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[25,50,{text:'All','value':-1}]"
            class="elevation-1"
            item-key="id"                            
            v-model="complex.selected"
            >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template slot="items" slot-scope="props">      
              <tr @click="branchRoute(props.item.id)" style="cursor: pointer">
                <td><v-chip v-bind:color="props.item.color" dark>{{ props.item.no }}</v-chip></td>
                <td>{{ props.item.akronim }}</td>
                <td>{{ props.item.name }}</td>                                                
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>              
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Partai';    

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/partai/form',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: 'No',   value: 'no'  },
              { text: 'Akronim', value: 'akronim'},
              { text: 'Name', value: 'name'},                                       
            ],
            items: []
        },
    }),  
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
        
        branchRoute (id) {
            this.$router.push({path:'/partai', query: {id: id}});
        },
    }
}
</script>
<style>
  #branch-scroll{
      height: calc(100vh - 161px);      
      overflow-y: auto;            
  }
  
  @media only screen and (max-width: 1000px) and (min-width:500px) {
    #branch-scroll{height: calc(100vh - 133px);}
  }
  @media only screen and (max-width: 500px) {
    #branch-scroll{height: calc(100vh - 148px);}
  }
</style>